function updateCartPrices() {
    // Get JSON data from the cart-price-data div
    let cartPricing = $("#cart-price-data").attr("data-json");

    //console.log(cartPricing);
    if (cartPricing) {

        $(".overide-Yes").hide();

        let pricingData = JSON.parse(cartPricing); // Convert JSON string to object

        // Loop through each selected option in the cart
        $(".extraPrice").each(function () {
            let selectedOption = $(this).attr("data-first").trim(); // Option name
            let selectedLast = $(this).attr("data-last").trim(); // Selected value
            let matchedPrice = ""; // Store matched price

            if (
                selectedOption == "Make" ||
                selectedOption == "model" ||
                selectedOption == "Shape" ||
                selectedOption == "Cover Fold Direction" ||
                selectedOption == "Strap Option" ||
                selectedOption.startsWith("Dimension") ||
                selectedOption == "Strap Location"
            ) {
                // Skip this option
            }
            // Find price for Tapers (First Letter Match)
            else if (selectedOption === "Taper") {
                pricingData.Tapers.forEach(function (taper) {
                    if (taper.short.substring(0, 1).toLowerCase() === selectedLast.substring(0, 1).toLowerCase()) {
                        matchedPrice = taper.cad.sale;
                    }
                });

                $(this).text(matchedPrice ?  matchedPrice : "Price: Not found");
            }

            // Find price for Premium Shape (First Letter Match)
            else if (selectedOption === "Premium Shape") { 
                pricingData.pShape.forEach(function (pShape) {
                    pShape.option.forEach(function (option) {
                        if (option.name.substring(0, 3).toLowerCase() === selectedLast.substring(0, 3).toLowerCase()) {
                            matchedPrice = option.cad.sale;
                        } 
                    });
                });
                $(this).text(matchedPrice ? matchedPrice : "Price: Not found");
            }
              
            // Find price for Handles (First 3 Letters Match)
            else if (selectedOption === "Handles") {
                pricingData.Handles.forEach(function (handle) {
                    if (handle.name.substring(0, 3).toLowerCase() === selectedLast.substring(0, 3).toLowerCase()) {
                        matchedPrice = handle.cad.sale;
                    }
                });

                $(this).text(matchedPrice ?  matchedPrice : "Price: Not found");
            }
            // Find price for Colour (Exact Match)
            else if (selectedOption === "Colours") {
                pricingData.Colour.forEach(function (color) {
                    if (color.name.toLowerCase() === selectedLast.toLowerCase()) {
                        matchedPrice = color.cad.sale;
                    }
                });

                $(this).text(matchedPrice ?  matchedPrice : "Price: Not found");
            }
            // Find price for Skirt Length (Exact Match)
            else if (selectedOption === "Skirt Length") {
                pricingData.SkirtLength.forEach(function (skirt) {
                    if (skirt.name.toLowerCase() === selectedLast.toLowerCase()) {
                        matchedPrice = skirt.cad.sale;
                    }
                });

                $(this).text(matchedPrice ?  matchedPrice : "Price: Not found");
            }
            // Find price for Accessories (First 3 Letters Match)
            else {
                if (selectedLast === "Yes") {
                    $(this).text("Find in Accessories");

                    pricingData.Assessories.forEach(function (accessory) {
                        if (accessory.name.substring(0, 3).toLowerCase() === selectedOption.substring(0, 3).toLowerCase()) {
                            matchedPrice = accessory.cad.sale;
                        }
                    });

                    $(this).text(matchedPrice ? matchedPrice : "Price: Not found");
                }
            }
        });
    } else {
        console.error("Cart pricing JSON not found!");
    }
}

// **🚀 Run on Page Load**
$(document).ready(
    //updateCartPrices()
);

// **🚀 Run When Cart is Updated**
$(document).ajaxComplete(function (event, xhr, settings) {
    if (settings.url.includes("/cart") || settings.url.includes("/update") || settings.url.includes("/change")) {
        //updateCartPrices();
    }
});
